import React from 'react'

const History = ({ width = 22, height = 22, ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 22 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>fechar</title>
    <defs>
      <path
        d="M2.45665,10.41807 C2.37481,10.41807 2.29142,10.40567 2.20865,10.38397 C1.70211,10.24757 1.40234,9.72677 1.53905,9.21837 C2.14231,6.98637 3.48554,4.97137 5.32198,3.54537 C6.24268,2.82927 7.26537,2.27437 8.36184,1.88997 C9.49613,1.49627 10.6856,1.29477 11.89739,1.29477 C13.10701,1.29477 14.29493,1.49317 15.42767,1.88997 C16.52228,2.27127 17.54404,2.82617 18.46443,3.53917 C19.37459,4.24287 20.16168,5.08607 20.804,6.04087 C21.45717,7.01117 21.94325,8.07447 22.24953,9.19667 C22.38748,9.70507 22.08864,10.22587 21.58272,10.36537 C21.07649,10.50177 20.55445,10.20417 20.41681,9.69577 C19.91802,7.86367 18.81101,6.21137 17.30069,5.03957 C15.74232,3.83367 13.87395,3.19507 11.89739,3.19507 C9.91742,3.19507 8.04657,3.83367 6.48696,5.04577 C4.97478,6.22067 3.86901,7.87917 3.37301,9.71437 C3.25862,10.13907 2.87546,10.41807 2.45665,10.41807 Z M11.89739,22.74987 C7.02388,22.74987 2.75642,19.46387 1.52014,14.75497 C1.38684,14.24657 1.69033,13.72887 2.19749,13.59557 C2.70527,13.46227 3.22421,13.76607 3.35751,14.27137 C4.37462,18.14637 7.8863,20.85267 11.89739,20.85267 C15.90817,20.85267 19.42016,18.14637 20.43727,14.27137 C20.57026,13.76297 21.08951,13.46227 21.59698,13.59557 C22.10445,13.72887 22.40763,14.24657 22.27464,14.75497 C21.03805,19.46387 16.7709,22.74987 11.89739,22.74987 Z M16.25878,17.42407 C16.01357,17.42407 15.76805,17.33107 15.58236,17.14197 L11.18966,12.68417 C11.0142,12.50747 10.91593,12.26877 10.91593,12.01767 L10.91593,6.63607 C10.91593,6.11217 11.34125,5.68747 11.86577,5.68747 C12.3906,5.68747 12.81561,6.11217 12.81561,6.63607 L12.81561,11.63017 L16.9352,15.80897 C17.30348,16.18097 17.29914,16.78237 16.92559,17.15127 C16.74052,17.33417 16.49965,17.42407 16.25878,17.42407 Z"
        id="path-1"
      />
    </defs>
    <g
      id="2.-Onde-usar"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="4.1-Onde-Usar-(desk)-Busca-focused"
        transform="translate(-88.000000, -259.000000)"
      >
        <g id="Group-5" transform="translate(63.000000, 197.000000)">
          <g id="fechar" transform="translate(24.000000, 61.000000)">
            <mask id="mask-2" fill="white">
              <use xlinkHref="#path-1" />
            </mask>
            <use
              id="icons-/-veloe-/-relógio"
              fill="#24206B"
              xlinkHref="#path-1"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default History
